import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Invoice } from '../../shared/models/invoice';
import { FormBuilder, FormGroup, FormArray, Validators, ValidationErrors, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-invoice-out-edit',
  templateUrl: './invoice-out-edit.component.html',
  styleUrls: ['./invoice-out-edit.component.scss'],
  providers: [ MessageService]
})
export class InvoiceOutEditComponent implements OnInit, OnChanges {

 	@Input() invoice: Invoice;
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();

 	form: FormGroup;


  	constructor(private fb: FormBuilder,
  		private messageService: MessageService,
  	) { }

	  ngOnInit() {
  		this._buildForm();
  	}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.invoice) {
            this.invoice = changes.invoice.currentValue;
            this._buildForm();
        }

    }

  	onSave() {
  		let c = Object.assign((new Invoice()), this.invoice, this.form.value);
  		this.save.emit(c.toRequest());
  	}

    getDetails(): FormArray {
      return <FormArray>this.form.get('details');
    }
    onCancel() {
      this.cancel.emit();
    }

  	_buildForm() {
      if (this.invoice) {
   		  this.form = this.fb.group({
   			  'number': [ this.invoice.number, [ Validators.required ] ],
   			  'note': [ this.invoice.note, [ ] ],
   			  'contact': [ this.invoice.contact, [ Validators.required ] ],
   			  'expertise': [ this.invoice.expertise, [  ] ],
   			  'date_document': [ this.invoice.date_document, [ Validators.required ] ],
   			  'date_echeance': [ this.invoice.date_echeance, [ Validators.required ] ],
          'details': this.fb.array(this._createItems())
  	    });
      }
    }

    removeDetail(idx: number) {
        (<FormArray>this.form.controls.details).removeAt(idx);
    }
    addDetail() {
        (<FormArray>this.form.controls.details).push(this.fb.group({
          'id': ['', []],
          'article': ['', []],
          'description': ['', []],
          'quantity': ['', []],
          'pu': ['', []],
          'rate': ['', []],
        }));
    }


    _createItems(): any[] {

        let a = (this.invoice.details || []).map(d => this.fb.group({
          'id': [d.id, []],
          'article': [d.article, []],
          'description': [d.description, []],
          'quantity': [d.quantity, []],
          'rate': [d.rate, []],
          'pu': [d.pu, []],
        }));
        console.log(a);
        return a;

    }


    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }

    }
}
